(() => {
  if (window.nativeBrowseViewsReady) return;
  window.nativeBrowseViewsReady = true;
  const storageKey = 'netritionBrowseView';
  const phone = window.matchMedia('(max-width: 599px)');
  const valid = value => value === 'grid' || value === 'list';
  let preferred;
  try { preferred = localStorage.getItem(storageKey); } catch (_) { /* Storage may be disabled. */ }

  function apply(root) {
    if (!root) return;
    const controls = root.querySelector('[data-native-view-controls]');
    if (!controls) return;
    const cartPreference = controls.dataset.defaultView;
    const view = valid(preferred) ? preferred : valid(cartPreference) ? cartPreference : phone.matches ? 'list' : 'grid';
    root.dataset.nativeView = view;
    controls.hidden = false;
    controls.querySelectorAll('[data-native-view]').forEach(button => {
      button.setAttribute('aria-pressed', String(button.dataset.nativeView === view));
    });
  }

  function initialize() { document.querySelectorAll('[data-native-browse]').forEach(apply); }
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-native-view]');
    if (!button || !button.closest('[data-native-view-controls]')) return;
    preferred = button.dataset.nativeView;
    if (!valid(preferred)) return;
    try { localStorage.setItem(storageKey, preferred); } catch (_) { /* Keep the current-page preference. */ }
    initialize();
  });
  document.addEventListener('native:browse:updated', event => apply(event.detail.root));
  phone.addEventListener('change', initialize);
  window.addEventListener('storage', event => {
    if (event.key === storageKey) { preferred = event.newValue; initialize(); }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
})();
